const FULL_WIDTH_MODULES = ['gift_finder'];

const isFullWidthBelowMedium = (moduleName) => FULL_WIDTH_MODULES.includes(moduleName);

export default isFullWidthBelowMedium;
